import {Component, OnDestroy, OnInit} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {TemplateService} from '../../services/template.service';
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {CALENDAR_LOCALE} from '../../services/constant';
import {SelectItem} from 'primeng/api';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from "rxjs";
import { CustomerService } from '../../services/customer.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [TemplateService]
})
export class SearchComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;

  selectedCompany: SelectItem[];
  company: any;
  allBranch = true;
  allDocType = true;
  branch: any;
  selectedBranch: SelectItem[];
  allBranchList: any = null;
  branchList: any = null;
  documentType: any;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  selectedType: any;
  inputText: any;
  tableData: any;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  totalItems = 0;
  selectedValues = [];
  currentPage = 1;
  checked = false;
  url: any;
  date: Date;
  loading = false;
  errorMsg = '';
  defaultLabel: any;
  modalData: any;

  selectedDepartment = null;
  departmentChoices: any[] = [];

  isSending = false;
  calendarLocale = CALENDAR_LOCALE.TH;
  loading_all_zip = false;
  cancel_loading_all_zip = false;
  loading_all_zip_message = '';
  loading_all_zip_progress = 0;
  tableArray = [];

  modal: NgbModalRef;
  allZipCount: number;
  allZipCurrent = 0;

  sortBy: string;
  sortMode: string;
  subs: Subscription;

  tableCol = [];

  approving = false;
  statusChoices = [];
  selectedStatus = '';
  selectedDocument: any;

  constructor(
    private apiService: ApiService,
    private authService: AuthenticationService,
    private customerService: CustomerService,
    private modalService: NgbModal,
    private template: TemplateService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.loadTexts();
    this.rdDocumentType = this.template.getDropdown();
  }

  get currentLang(): string {
    return this.translate.currentLang;
  }

  loadTexts() {
    this.statusChoices = [
      {value: '', label: this.translate.instant('COMMON.ALL')},
      {value: 'active', label: this.translate.instant('COMMON.STATUS.ACTIVE')},
      {value: 'pending', label: this.translate.instant('COMMON.STATUS.PENDING')},
      {value: 'customer_approved', label: this.translate.instant('COMMON.STATUS.CUSTOMER-APPROVED')},
      {value: 'customer_rejected', label: this.translate.instant('COMMON.STATUS.CUSTOMER-REJECTED')},
      {value: 'cancelled', label: this.translate.instant('COMMON.STATUS.CANCELLED')},
    ]

    this.defaultLabel = this.translate.instant('COMMON.ALL');
    this.tableCol = [];
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      this.rdDocumentType = this.template.getDropdown();
      this.loadInput();
      this.tableCol.push(
        {field: 'invoice_number', header: this.translate.instant('FILTER.DOCUMENT-NUMBER')},
        {field: 'header_issue_date', header: this.translate.instant('FILTER.DATE-OF-ISSUE')},
        {field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME')},
        {field: 'rd_doc_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
        {field: 'total_items_total_payment', header: this.translate.instant('TABLE.SALES')}
      );
      this.tableCol = _.uniqBy(this.tableCol, 'field');
    });
  }

  loadInput() {
    this.selectedCompany = null;
    this.company = null;
    this.company = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
        this.company = _.uniqBy(this.company, 'label');
      },
      error => error(status)
    );

    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();

    this.selectedDepartment = null;
    this.departmentChoices = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getDepartments().subscribe(
      (departments: any[]) => {
        this.departmentChoices = [{
          label: this.translate.instant('COMMON.ALL'),
          value: null
        }];
        _.forEach(departments, (obj) => {
          this.departmentChoices.push({
            label: obj.name_en,
            value: obj.id
          });
        });
        this.departmentChoices = _.uniqBy(this.departmentChoices, 'label');
      },
      (error) => {
        console.log(error);
      }
    );

    this.searchButtonClicked();
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany == null || obj.corporate === this.selectedCompany) {
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
      }
    });
  }

  filterData(query, field, dataList) {
    query = query.toLowerCase().trim();

    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      const data = dataList[i];
      if (data[field].toLowerCase().indexOf(query) >= 0) {
        filtered.push(data);
      }
    }
    return filtered;
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.loadData(params);
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  clearSearch() {
    this.selectedType = null;
    this.inputText = null;
    this.selectedCompany = null;
    this.branch = null;
    this.documentType = null;
    this.allDocType = true;
    this.allBranch = true;
    this.selectedBranch = null;
    this.selectedDepartment = null;
    this.selectedRdDocumentType = null;
    this.selectedStatus = '';
    this.sortBy = null;
    this.sortMode = null;
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
    this.searchButtonClicked();
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.loadData();
  }

  loadData(params?) {
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      return;
    }

    const data = {
      status: this.selectedStatus || '',
      rd_doc_type: this.selectedRdDocumentType,
      search_box: this.inputText,
      header_issue_date_start: this.startDate == null ? this.startDate : moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end: this.endDate == null ? this.endDate : moment(this.endDate).format('YYYY-MM-DD'),
      company_id: this.selectedCompany,
      branch_id: this.selectedBranch ? this.selectedBranch : null,
      department_id: this.selectedDepartment || '',
      items_per_page: this.itemsPerPage
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    this.loading = true;

    this.apiService.postSearch(data, params).subscribe(
      (res: any) => {
        this.tableData = res.results;
        this.totalItems = res.count;

        this.selectedValues = [];
        for (let i = 0; i < this.tableData.length; i++) {
          this.selectedValues.push(false);
        }

        this.loading = false;
      }
    );
  }

  DownloadSelected(content, doc_type) {
    this.tableArray = [];

    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i]) {
        continue;
      }
      this.tableArray.push(this.tableData[i]);
    }

    if (!_.isEmpty(this.tableArray)) {
      this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
      this.allZipCount = this.tableArray.length;
      this.cancel_loading_all_zip = false;

      if (doc_type === 'xml') {
        this.download(0, this.tableArray, 'xml_file');
      } else {
        this.download(0, this.tableArray, 'pdf_file');
      }
    }
  }

  EnabledDownloadSelected() {
    return this.selectedValues.filter(select => select === true).length > 0;
  }

  download(index, tableArray, url_field_name) {
    this.loading_all_zip = true;

    if (index >= tableArray.length) {
      this.loading_all_zip = false;
      this.loading_all_zip_message = this.translate.instant('TEXT.DOWNLOAD-COMPLETE') + ' ' + '(' +
        this.translate.instant('FILTER.ALL') + ' ' + tableArray.length + ' ' +
        this.translate.instant('COMMON.ITEMS') + ')';
      return;
    }

    if (this.cancel_loading_all_zip) {
      return;
    }

    const download_url = tableArray[index][url_field_name];

    // skip if download url is empty.
    if (download_url == null || download_url.length == 0) {
      this.download(index + 1, tableArray, url_field_name);
      return;
    }

    this.apiService.downloadFileFromMediaPath(download_url).subscribe(
      (obj) => {
        if (this.cancel_loading_all_zip) {
          return;
        }

        // this.loading_all_zip = false;
        let filename = this.getFileName(tableArray[index]);
        const taxImportPdfName = tableArray[index].tax_import_pdf_name;

        if (url_field_name === 'xml_file') {
          filename = filename + '.xml';
          this.sniff('DOWNLOAD_XML', filename);
        } else {
          filename = taxImportPdfName ? taxImportPdfName : filename + '.pdf';
          this.sniff('DOWNLOAD_PDF', filename);
        }
        this.apiService.createDownloadFile(obj, filename);
        this.allZipCurrent++;
        this.loading_all_zip_progress = (this.allZipCurrent / this.allZipCount) * 100;
        // data.xmlLoading = false;
        setTimeout(() => {
          this.download(index + 1, tableArray, url_field_name);
        }, 1000);
      },
      error => {
        this.loading_all_zip = false;
        this.loading_all_zip_message = this.translate.instant('ERROR.TRY-AGAIN');
        // data.xmlLoading = false;
      }
    );
  }

  closeDownloadAll() {
    this.modal.close();
    this.cancel_loading_all_zip = true;
    this.loading_all_zip = false;
    this.allZipCurrent = 0;
    this.loading_all_zip_progress = 0;
  }

  getFileName(data) {
    const rd_doc_type = data.rd_document_type === 'other' ? data.document_type__type : data.rd_document_type;
    return data.header_invoice_number + '_' + rd_doc_type + '_' + data.issue_dt_only_date;
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      return;
    }
    this.deselectAll();
  }

  selectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = true;
    }
  }

  deselectAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = false;
    }
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY')
        + ' ' + errorMsgList.join(', ')
        + ' ' + this.translate.instant('COMMON.CORRECT');
      return;
    }
  }

  closeCancelModal() {
    this.modal.close();
    this.selectedDocument = undefined;
  }

  openMailModal(event, modalSendEmail, index) {
    this.modalData = this.tableData[index];
    this.modalData.status_send_email = 'not_yet_sent';
    this.modal = this.modalService.open(modalSendEmail, {keyboard: false, centered: true});
    this.modalData.email_sent_msg = null;
  }

  closeMailModal() {
    this.modal.close();
    this.modalData.email_sent_msg = null;
  }

  sendMail() {
    this.isSending = true;
    const data = {
      tax_data_id: this.modalData.tax_data_id,
      email: this.modalData.buyer_email,
      cc_email: this.modalData.buyer_cc_email
    };
    this.apiService.sendEmailETaxInvoice(data).subscribe(
      (res: any) => {
        this.modalData.email_sent_msg = res.message;
        this.modalData.status_send_email = 'sent';
        const sniffData = `${this.modalData.header_invoice_number}`;
        this.sniff('SEND_EMAIL', sniffData);
        this.isSending = false;
      },
      (err: any) => {
        this.modalData.email_sent_msg = err.error;
        this.modalData.status_send_email = 'blank_duplicated_invalid';
        this.isSending = false;
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'DOC_SEARCH',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  getDataStatusDisplay(status) {
    let statusDisplay: string;
    switch (status) {
      case 'pending': {
        statusDisplay = this.translate.instant('COMMON.STATUS.PENDING');
        break;
      }
      case 'active': {
        statusDisplay = this.translate.instant('COMMON.STATUS.ACTIVE');
        break;
      }
      case 'customer_approved': {
        statusDisplay = this.translate.instant('COMMON.STATUS.CUSTOMER-APPROVED');
        break;
      }
      case 'customer_rejected': {
        statusDisplay = this.translate.instant('COMMON.STATUS.CUSTOMER-REJECTED');
        break;
      }
      case 'cancelled': {
        statusDisplay = this.translate.instant('COMMON.STATUS.CANCELLED');
        break;
      }
      default: {
        statusDisplay = '-'
      }
    }
    return statusDisplay
  }

  openConfirmationModal(modalContent, data) {
    this.selectedDocument = data;
    this.modal = this.modalService.open(modalContent, {centered: true, backdrop: 'static'});
  }

  bypassApproveDocument() {
    if (!this.selectedDocument) {
      return;
    }

    this.approving = true;
    this.customerService.userApproveTaxData(this.selectedDocument.secret_code).subscribe(
      () => {
        this.approving = false;
        this.closeCancelModal();
        this.loadData();
      },
      (error) => {
        this.approving = false;
        this.closeCancelModal();
      }
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}




// WEBPACK FOOTER //
// /opt/app/src/app/features/search/search.component.ts